import React, { useState, useEffect, useCallback, useRef } from "react";

var interval;

export default function WaitingTimer(props) {
  //console.log("TimerComponent Fired");
  const [seconds, setSeconds] = useState(props.waitingSeconds);
  const [min, setMinutes] = useState(0);
  const [hr, setHours] = useState(0);
  const increment = useRef(null);
  //const [isActive, setIsActive] = useState(props.timerState);

  const formatTime = () => {
    const getSeconds = `0${seconds % 60}`.slice(-2);
    const minutes = `${Math.floor(seconds / 60)}`;
    const getMinutes = `0${minutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(seconds / 3600)}`.slice(-2);

    return `${getHours}:${getMinutes}:${getSeconds}`;
  };

  const calculateTime = useCallback(() => {
    if (props.timerState) {
      increment.current = setInterval(() => {
        setSeconds((seconds) => seconds + 1);
      }, 1000);
    } else if (!props.timerState && seconds !== 0) {
      clearInterval(increment.current);
    }
  });

  useEffect(() => {
    // setSeconds((seconds) => seconds + props.waitingSeconds);
    calculateTime();

    return () => {
      if (!props.timerState) {
        clearInterval(increment.current);
        //console.log("Timer Interval Cleared")
      }
    };
  }, [props.timerState]);

  return <React.Fragment>{formatTime()}</React.Fragment>;
}
